export default ({ axios, withoutInvalidValues }) => ({
  create: (body) => axios.post(`/chat-messages/batch-send`, withoutInvalidValues(body))
})